export default "__VITE_ASSET__D_sP01A9__"